<template>
    <div id="auth_main">
        <div class="auth_container" v-if="isLoaded">
            <auth-header :companyId="companyId"></auth-header>
            <login v-if="isLogin"></login>
            <create-account v-if="!isLogin"></create-account>
            <!-- <div v-for="(color, index) in colors" :key="color">
                <span :style="{color: color}">Cor: {{color}} ___ {{index}}</span>
            </div> -->
        </div>
        <div class="loader" v-if="!isLoaded">
            <loader></loader>
        </div>
    </div>
</template>

<script>

import Loader from '../../components/Loaders/LoaderFull'
import AuthHeader from '../../components/header/AuthHeader'
import Login from './Login'
import CreateAccount from './CreateAccount'

export default {
    components: {
        'auth-header': AuthHeader,
        'login': Login,
        'create-account': CreateAccount,
        'loader': Loader,
    },

    data: () =>({
        companyId: '',
        urlParameter: '',
        colors: '',
        isLogin: true,
        isLoaded: false
    }),

    created(){
        this.urlParameter = this.$route.query
        console.log('URL serv: ', process.env.VUE_APP_HOST_FUNCTIONS_SERV_CAT)

        this.getWorkspace()
        // this.colors = this.$store.getters.getCustomColors
        // console.log('Colors: ', this.colors);
    },

    methods:{
        async getWorkspace(){
            try {
                let workspaceReq = await this.$http.get(`${process.env.VUE_APP_HOST_FUNCTIONS_SERV_CAT}/workspaces/${this.urlParameter.workspaceId}`)

                this.companyId = workspaceReq.body.workspace.companyId
                this.colors = workspaceReq.body.workspace.colors
                this.$store.commit('setColorsState', this.colors)
                this.$store.commit('setEssentialInfo',  workspaceReq.body.workspace)
                this.isLoaded = true
                console.log('Company ID: ', this.companyId)
                console.log('workspace REQ: ', this.colors)

            } catch (error) {
                console.error('Erro na requisição de Workspace: ', error);
                
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    #auth_main{
        // height: 100vh;
        .auth_container{
            height: 100vh;
        }
    }
</style>
